import { useState, useEffect, useMemo } from "react";
import "./Categories.scss";
import { FiBookOpen, FiTrash2, FiSave } from "react-icons/fi";
import { Input, App, Modal, Button, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { sendBillAction } from "../../../components/action/SendBillAction";
import { useProductStore } from "../../../store/Products";
import { useStore } from "../../../components/globalstate/GlobalState";



const Categories = ({ onFilterChange }) => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [billName, setBillName] = useState("");
  const { message } = App.useApp();
  const setId = useStore((state) => state.setId);


  // ✅ Get Zustand state & actions
  const { products, fetchProducts, loading } = useProductStore();

  // ✅ Fetch products when component mounts
  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // ✅ Compute categories dynamically from API data
  const categories = useMemo(() => {
    const types = Array.from(new Set(products.map((item) => item.type)));
    return [
      { name: "All", count: products.length },
      ...types.map((type) => ({
        name: type,
        count: products.filter((item) => item.type === type).length,
      })),
    ];
  }, [products]);

  // ✅ Filtered items
  const filteredItems = useMemo(() => {
    return products.filter((item) => {
      const matchCategory = activeCategory === "All" || item.type === activeCategory;
      const matchSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
      return matchCategory && matchSearch;
    });
  }, [products, activeCategory, searchTerm]);

  // ✅ Notify parent component
  useEffect(() => {
    onFilterChange(filteredItems);
  }, [filteredItems, onFilterChange]);

  const handleClick = (categoryName) => {
    setActiveCategory(categoryName);
  };

  let billId = localStorage.getItem("billId");

  const openSaveModal = () => setIsModalVisible(true);

  const handleSaveConfirm = () => {
    if (billId) {
      sendBillAction("save-bill", {}, {}, message, billName);
      localStorage.removeItem("billId");
      setBillName("");
      setIsModalVisible(false);
      setId("");
    }
  };

  const handleDelete = () => {
    if (billId) {
      sendBillAction("delete-bill", {}, {}, message);
      localStorage.removeItem("billId");
    }
  };

  if (loading) return <></>;

  return (
    <div className="menu-slider">
      <div className="frame-left-slider">
        <div className="menu-left">
          <FiBookOpen className="icon" />
          <span>Drink Menu</span>
        </div>

        <div className="menu-tabs">
          {categories.map((item, index) => (
            <button
              key={index}
              className={`tab ${activeCategory === item.name ? "active" : ""}`}
              onClick={() => handleClick(item.name)}
            >
              <p>{item.name}</p>
              <span className="count">{item.count}</span>
            </button>
          ))}
        </div>

        <div className="menu-right">
          <Input
            className="search-box"
            placeholder="Search Menu"
            prefix={<SearchOutlined />}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="frame-bill-id">
        <hr />
        <div className="button-id-bill">
          <div className="frame-group-button-delete-save">
            <Button
              type="primary"
              className="custom-save-btn"
              icon={<FiSave />}
              onClick={openSaveModal}
              disabled={!billId}
            >
              Save
            </Button>
            <Button
              type="primary"
              // danger
              className={`custom-delete-btn ${!billId ? "custom-delete-btn-disabled" : ""}`}
              icon={<FiTrash2 />}
              onClick={handleDelete}
              disabled={!billId}
            >
              Delete
            </Button>
          </div>
          <p>{billId ? `Bill #${billId}` : ""}</p>
        </div>
      </div>

      <Modal
        title="Save Bill"
        open={isModalVisible}
        onOk={handleSaveConfirm}
        onCancel={() => setIsModalVisible(false)}
        okText="Save"
        cancelText="Cancel"
      >
        <Input
          placeholder="Enter bill name"
          value={billName}
          onChange={(e) => setBillName(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default Categories;

